import apiClient from '../axios';
import { CreateReportRequest } from '../types/Report.api.type';

const REPORT_URL = () => '/api/report';

export const reportApi = {
  createReport: (params: CreateReportRequest) => {
    return apiClient.post(`${REPORT_URL()}/createReport`, params);
  },
  getIsReport: (questionId: string) => {
    return apiClient.get(`${REPORT_URL()}/getIsReport`, {
      params: {
        questionId,
      },
    });
  },
};
